import { locationSurchargeType } from "./location-surcharge-type.const";
import { LocationSurchargeBase } from "./location-surcharge-base.model";
import { LocationSurcharge } from "./location-surcharge.type";
import { LocationSurchargeMapper } from "./location-surcharge.mapper";
import { Carrier } from "../../carrier/carrier.model";
import { LclQuoteLocationSurcharge } from "../../quote/quote-surcharge/models/quote-location-surcharge-lcl.model";
import { LclQuote } from "../../quote/models/quote-lcl.model";
import { CurrencyRoundPipe } from "../../shared/currencies/currency-round.pipe";
import { SurchargeTypeMapper } from "app/surcharge-type/surcharge-type.mapper";
import { SurchargeType } from "app/surcharge-type/surcharge-type.model";

export class LclLocationSurcharge extends LocationSurchargeBase {
  constructor(
    public id: number,
    public discriminator: string,
    public name: string = "",
    protected carrier: Carrier,
    protected type: string = locationSurchargeType.destination,
    protected weightPrice: number = 0,
    protected measurementPrice: number = 0,
    protected shipmentPrice: number = 0,
    protected piecePrice: number = 0,
    protected documentPrice: number = 0,
    protected minPrice: number = 0,
    protected maxPrice: number = 0,
    protected assignment: string = "",
    protected quoteLocationSurcharges: LclQuoteLocationSurcharge[],
    public currency: string = "USD",
    public surchargeType?: SurchargeType,
    public debugInfo?: string,
    public chargedFor?: string,
    public internalNote?: string,
    public availableOnline?: boolean,
    public sort?: number,
  ) {
    super(
      id,
      discriminator,
      name,
      carrier,
      type,
      assignment,
      quoteLocationSurcharges,
      currency,
      surchargeType,
      debugInfo,
      chargedFor,
      internalNote,
      sort,
    );
  }

  public getWeightPrice(): number {
    return this.weightPrice;
  }
  public setWeightPrice(param: number) {
    this.weightPrice = param;
  }

  public getMeasurementPrice(): number {
    return this.measurementPrice;
  }
  public setMeasurementPrice(param: number) {
    this.measurementPrice = param;
  }

  public getShipmentPrice(): number {
    return +this.shipmentPrice;
  }
  public setShipmentPrice(param: number) {
    this.shipmentPrice = param;
  }

  public getPiecePrice(): number {
    return this.piecePrice;
  }
  public setPiecePrice(param: number) {
    this.piecePrice = param;
  }

  public getDocumentPrice(): number {
    return this.documentPrice;
  }
  public setDocumentPrice(param: number) {
    this.documentPrice = param;
  }

  public getMinPrice(): number {
    return this.minPrice;
  }
  public setMinPrice(param: number) {
    this.minPrice = param;
  }

  public getMaxPrice(): number {
    return this.maxPrice;
  }
  public setMaxPrice(param: number) {
    this.maxPrice = param;
  }

  // TODO: This Logic should be moved to the API !!
  public get total(): number {
    if (!this.haveQuoteLocationSurcharges()) {
      return 0;
    }
    const quoteLocationSurcharge = this.getFirstQuoteLocationSurcharge();
    const quote = quoteLocationSurcharge.getQuote();

    if (
      quote instanceof LclQuote &&
      quoteLocationSurcharge instanceof LclQuoteLocationSurcharge
    ) {
      const quoteMeasurement = quote.getMeasurement();
      const quoteWeight = quote.getWeight();
      const chargeWeightPrice = this.getWeightPrice();
      let freight: number;

      // 1. Calculate Bigger Charge Value
      freight = Math.max(
        Number(quoteWeight) *
          (Number(chargeWeightPrice) +
            Number(quoteLocationSurcharge.getWeightPrice())),
        Number(quoteMeasurement) *
          (Number(this.getMeasurementPrice()) +
            Number(quoteLocationSurcharge.getMeasurementPrice())),
      );

      // 3. Add Shipment Price
      freight +=
        Number(this.getShipmentPrice()) +
        Number(quoteLocationSurcharge.getShipmentPrice());

      // 4. Add Piece Price
      freight +=
        (Number(this.getPiecePrice()) +
          Number(quoteLocationSurcharge.getPiecePrice())) *
        Number(quote.getPieces());

      // 5. Add Document Price
      freight +=
        Number(this.getDocumentPrice()) +
        Number(quoteLocationSurcharge.getDocumentPrice());

      // 6. Apply Min and Max
      freight = this.getMaxPrice()
        ? Math.min(freight, this.getMaxPrice())
        : freight;
      freight = this.getMinPrice()
        ? Math.max(freight, this.getMinPrice())
        : freight;

      return new CurrencyRoundPipe().transform(freight);
    }

    return 0;
  }

  public getFirstQuoteLocationSurcharge(): LclQuoteLocationSurcharge {
    if (this.haveQuoteLocationSurcharges()) {
      return this.quoteLocationSurcharges[0];
    }
  }

  public getRequestParams() {
    return {
      weightPrice: this.getWeightPrice(),
      measurementPrice: this.getMeasurementPrice(),
      minPrice: this.getMinPrice(),
      maxPrice: this.getMaxPrice(),
      shipmentPrice: this.getShipmentPrice(),
      piecePrice: this.getPiecePrice(),
      documentPrice: this.getDocumentPrice(),
      carrier: this.getCarrier() ? this.getCarrier().getId() : null,
      name: this.getName(),
      type: this.getType(),
      availableOnline: this.availableOnline,
      sort: this.sort,
      surchargeType: this.getSurchargeType()
        ? this.getSurchargeType().getId()
        : null,
    };
  }

  public getClone(): LocationSurcharge {
    return LocationSurchargeMapper.map({
      id: this.id,
      discriminator: this.discriminator,
      name: this.name,
      carrier: this.carrier,
      type: this.type,
      weightPrice: this.weightPrice,
      measurementPrice: this.measurementPrice,
      shipmentPrice: this.shipmentPrice,
      piecePrice: this.piecePrice,
      documentPrice: this.documentPrice,
      minPrice: this.minPrice,
      maxPrice: this.maxPrice,
      assignment: this.assignment,
      quoteLocationSurcharges: this.quoteLocationSurcharges,
      currency: this.currency,
      availableOnline: this.availableOnline,
      sort: this.sort,
      chargedFor: this.chargedFor,
      debugInfo: this.debugInfo,
      surchargeType: SurchargeTypeMapper.map(this.getSurchargeType()),
    });
  }
}
